import styled from '@emotion/styled';

export const TitlePrivacy = styled.h2(() => `
font-size: 16px;
@media (min-width: 600px){
font-size: 20px;
}
`);

export const Title = styled.h4(() => `
text-align: left;
font-size: 14px;
@media (min-width: 600px){
font-size: 16px;
}
`);

export const Description = styled.p(() => `
text-align: left;
font-size: 12px;
@media (min-width: 600px){
font-size: 14px;
}
`);